<div id="modal-content-wrapper">
  <div class="card card-secondary card-outline">
    <div class="card-header bg-light">
      <h4 class="card-title mb-0">Papel de Trabalho Não Cadastrado</h4>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="cancelar()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-2" style="min-height: auto !important;">
      <div class="row">
        <div class="form-group col-md-4">
          <label for="papelTrabalho" class="mb-1">Papel de Trabalho</label>
          <input maxlength="100" id="papelTrabalho"  style="width: 390px" class="form-control form-control-lg" placeholder="informe o nome do novo Papel de Trabalho" [(ngModel)]="novoItem">
        </div>
      </div>
    </div>

    <div class="card-footer p-2">
      <button
        type="button"
        class="btn btn-primary btn-sm mr-1"
        (click)="salvar()"
      >
        <i class="fas fa-check"></i> Adicionar
      </button>

      <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
        <i class="fas fa-times"></i> Cancelar
      </button>
    </div>
  </div>
</div>
